import React from 'react';
import { FaCheckCircle, FaUsers, FaHistory, FaMedal, FaHandshake } from 'react-icons/fa';
import './About.css';
import cdUpadhyay from '../assets/cdUpadhyay.png';  
import SP from '../assets/SP.png';
import workers from '../assets/workers.jpg';
import ourStory from '../assets/Our Story.png'

const About = () => {
  return (
    <div className="about-page">
      {/* Page Header */}
      <div className="page-headerAbout">
        <div className="container">
          <h1>About Us</h1>
          <p>Learn more about Preferbuild Construction Company</p>
        </div>
      </div>
      
      {/* Company Overview */}
      <section className="section company-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-image">
              <img src={ourStory} alt="Preferbuild Construction Team" />
            </div> 
            <div className="overview-content">
              <h2 className="section-title left-align">Our Story</h2>
              <p>
                Founded in 1983, Preferrobuild Construction Company has established itself as a leader in the ferrocement construction industry, delivering exceptional quality and service to our clients. What started as a small team with big dreams has grown into a full-service construction company with a reputation for excellence.
              </p>
              <p>
                With over 40 years of experience, we've successfully completed hundreds of projects ranging from residential homes to commercial buildings, always maintaining our commitment to quality, reliability, and client satisfaction.
              </p>
              <p>
                At Preferbuild, we believe in building not just structures, but relationships. Our team of skilled professionals works closely with clients throughout the construction process to ensure that every detail is perfected and every expectation is exceeded.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Mission & Vision */}
      <section className="section mission-vision">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-box">
              <h3>Our Mission</h3>
              <p>
                To deliver exceptional ferrocement construction services through innovation, quality craftsmanship, and unwavering commitment to client satisfaction, while maintaining the highest standards of safety and environmental responsibility.
              </p>
            </div>
            <div className="vision-box">
              <h3>Our Vision</h3>
              <p>
                To be the leading ferrocement construction company known for excellence, integrity, and innovation, building structures that stand the test of time and relationships that last a lifetime.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Core Values */}
      <section className="section core-values">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <FaCheckCircle />
              </div>
              <h3>Quality</h3>
              <p>
                We are committed to delivering the highest quality in every project, big or small, ensuring durability, functionality, and aesthetic appeal.
              </p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <FaHandshake />
              </div>
              <h3>Integrity</h3>
              <p>
                We conduct our business with honesty, transparency, and ethical practices, building trust with our clients, partners, and community.
              </p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <FaUsers />
              </div>
              <h3>Teamwork</h3>
              <p>
                We foster a collaborative environment where diverse talents and perspectives come together to achieve common goals and exceptional results.
              </p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <FaMedal />
              </div>
              <h3>Excellence</h3>
              <p>
                We strive for excellence in all aspects of our work, continuously improving our skills, processes, and standards to exceed expectations.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Team Section */}
      <section className="section team-section">
        <div className="container">
          <h2 className="section-title">Meet Our Leadership Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <img src={cdUpadhyay} alt="CD Upadhyay" />
              </div>
              <h3>Chandradhar Upadhyay</h3>
              <p className="member-title">CEO & Founder</p>
              <p className="member-bio">
                With over 40 years of experience in the ferrocement construction industry, CD Upadhyay founded Preferbuild with a vision to create a company that prioritizes quality and client satisfaction.
              </p>
            </div>
            
            {/* <div className="team-member">
              <div className="member-image">
                <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" alt="Emily Davis" />
              </div>
              <h3>ABC</h3>
              <p className="member-title">Chief Operations Officer</p>
              <p className="member-bio">
                Emily oversees all operational aspects of Preferbuild, ensuring efficient processes, quality control, and seamless project execution.
              </p>
            </div> */}
            
            <div className="team-member">
              <div className="member-image">
                <img src={workers} alt="workers" />
              </div>
              <h3>Professional Workers</h3>
              <p className="member-title">Skilled Team of Workers</p>
              <p className="member-bio">
                Our skilled team of workers brings expertise and dedication to every project, ensuring high-quality craftsmanship and attention to detail.
              </p>
            </div>
            
            <div className="team-member">
              <div className="member-image">
                <img src={SP} alt="Shivam Pathak" />
              </div>
              <h3>Shivam Pathak</h3>
              <p className="member-title">Website and Media Manager</p>
              <p className="member-bio">
                Shivam manages our online presence and media relations, ensuring that our brand is effectively communicated across all platforms.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Company History */}
      <section className="section history-section">
        <div className="container">
          <h2 className="section-title">Our Journey</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-dot">
                <FaHistory />
              </div>
              <div className="timeline-content">
                <h3>1983</h3>
                <p>Preferbuild Construction Company was founded by C.D Upadhyay with a small team of five professionals.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-dot">
                <FaHistory />
              </div>
              <div className="timeline-content">
                <h3>1993</h3>
                <p>Completed our first major commercial project, establishing our reputation in the commercial construction sector.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-dot">
                <FaHistory />
              </div>
              <div className="timeline-content">
                <h3>2000</h3>
                <p>Expanded our services to include architectural design, offering clients a complete construction solution.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-dot">
                <FaHistory />
              </div>
              <div className="timeline-content">
                <h3>2015</h3>
                <p>Received the Industry Excellence Award for our commitment to quality and innovation in construction.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-dot">
                <FaHistory />
              </div>
              <div className="timeline-content">
                <h3>2020</h3>
                <p>Celebrated our 40th anniversary and opened a new premises to accommodate our growing team.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-dot">
                <FaHistory />
              </div>
              <div className="timeline-content">
                <h3>2023</h3>
                <p>Implemented sustainable construction practices across all projects, reinforcing our commitment to environmental responsibility.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-dot">
                <FaHistory />
              </div>
              <div className="timeline-content">
                <h3>Present</h3>
                <p>Continuing to grow and innovate while maintaining our core values and commitment to excellence.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
